import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { init } from 'echarts';
import { NzCheckboxOption } from 'ng-zorro-antd/checkbox';
import { ApplicationRole, ApplicationRoleMapping } from 'src/app/core/models/ApplicationRole';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { AdminService } from '../admin.service';
import { UserService } from 'src/app/core/services/user.service';
import { CompanyModel } from 'src/app/core/models/CompanyModel';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { User } from 'src/app/core/models/user';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Constants } from 'src/app/constants/constants';

@Component({
  selector: 'app-add-user',
  standalone: false,
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.less']
})
export class AddUserComponent implements OnInit {
  addUserForm!: FormGroup;
  searchForm!: FormGroup;
  applicationRoles = Object.values(ApplicationRole).filter(value => typeof value === 'number');
  selectedUserType = 0;
  userSearch = '';
  checkboxOptions: NzCheckboxOption[] = [];
  userExist = false; // To toggle readonly state
  errorMessage = ''; // To display error messages
  displayErrorMsg = false; // To control error message visibility
  buttonLabel = 'Get User Details'; // To dynamically change button label
  selectedRoles: number[] = []; // To store selected roles
  userMaster: RegisteredUserModel[] = [];
  companyMaster: any[] = [];
  blockMaster: any[] = [];
  roles: any[] = [];
  newUser = new RegisteredUserModel();
  selectedCompany = new CompanyModel();
  selectedBlock = new BlockModel();
  currentUser: User = new User();
  isSimulationEnabled = false; // To control simulation mode

  constructor(private router: Router,
    private fb: FormBuilder,
    private adminService: AdminService,
    private userService: UserService,
    private messageService: NzMessageService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    if (this.currentUser.IsRFCAdmin) {
      this.newUser.Is_Partner = false;
      this.selectedCompany.Company_Code = 0;
      this.selectedBlock.Block_Code = 0;
      this.selectedRoles = [];
    }
    else {
      this.router.navigate(['/unauthorize']);
    }

    // Initialize searchForm first, then addUserForm
    this.initializeSearchFormAsync()
      .then(() => this.initializeAddUserFormAsync())
      .then(() => {
        //this.mapApplicationRolesToCheckboxOptions(); // Map roles to checkbox options after both are initialized
        this.bindCompanyAndBlock(); // Bind company and block data
        
      })
      .catch(error => {
        console.error('Error initializing forms:', error);
      });
    if (!this.isSimulationEnabled) {
      this.adminService.getAllRegisteredUsers().subscribe((response: any) => {
        this.userMaster = response.output;
      });
    }
  }
  initializeAddUserFormAsync(): Promise<void> {
    return new Promise((resolve) => {
      this.addUserForm = this.fb.group({
        userName: [{ value: '', disabled: true }],
        email: [{ value: '', disabled: true }],
        cai: [{ value: '', disabled: true }],
        jobTitle: [{ value: '', disabled: true }],
        ctn: [{ value: '', disabled: true }],
        company: ['', !this.isPartner ?  null : Validators.required], // Company dropdown
        block: ['', !this.isPartner ? null : Validators.required], // Block dropdown
        applicationRoles: this.fb.array([]) // Initialize as FormArray
      });
      resolve();
    });
  }

  initializeSearchFormAsync(): Promise<void> {
    return new Promise((resolve) => {
      this.searchForm = this.fb.group({
        userType: ["0"], // Default to "Chevron"
        userSearch: ['', Validators.required] // Required field
      });

      resolve();
    });
  }
  mapApplicationRolesToCheckboxOptions(): void {
    // Map ApplicationRole to checkboxOptions
    var tempRoles = this.isPartner ? this.applicationRoles.slice(5,7) : this.applicationRoles.slice(0,5);
    this.checkboxOptions = tempRoles.map(role => ({
      label: ApplicationRoleMapping[role as ApplicationRole], // Map role to its label
      value: role
    }));
    // Populate the FormArray with controls for each role
    this.checkboxOptions.forEach(() => {
      this.applicationRolesArray.push(this.fb.control(false)); // Add a control for each checkbox
    });
    
  }
  get applicationRolesArray(): FormArray {
    return this.addUserForm.get('applicationRoles') as FormArray;
  }
  get isPartner(): boolean {
    return this.searchForm.get('userType')?.value === '1'; // Convert to boolean
  }

  onSubmit(): void {
    if(this.addUserForm.valid)
      this.createNewUser();
    else
      this.messageService.error("Please fill all the required fields", {nzDuration: Constants.SHOW_MESSAGE_DURATION});
  }
  getUserDetails1() {    
    this.errorMessage = ''; // Reset error message
    if (this.searchForm.invalid) {
      this.errorMessage = 'User Search is required.';
      return;
    }
    this.userExist = false; // Reset user existence state
    
    const formValue = this.searchForm.value;    
    //this.addUserForm.reset(); // Reset the addUserForm
    // Simulate an API call to check if the user exists
    if (!this.addUserForm) {
      
      this.errorMessage = 'Form is not ready. Please try again later.';
      return;
    }
    const userExists = formValue.userSearch === '1'; // Simulated condition
    if (userExists) {
      // Populate the form with user details MANAS_TBD
      this.addUserForm.patchValue({
        userName: 'John Doe',
        email: 'johndoe@example.com',
        cai: '12345',
        jobTitle: 'Software Engineer',
        ctn: '67890'
      });
      this.userExist = true; // Make the form readonly      
      this.buttonLabel = 'Reset';
      this.enableSerachForm(false); // Disable the search form
    } else {
      // Show error message and change button label
      this.errorMessage = 'No User found';
      this.enableSerachForm(true); // Enable the search form
    }

  }
  resetSearForm(): void {
    // Reset the form and states
    this.searchForm.patchValue({ userSearch: '' });
    this.userExist = false;
    this.errorMessage = '';
    this.buttonLabel = 'Get User Details';
    this.selectedRoles = [];
    this.enableSerachForm(true);
  }
  enableSerachForm(isEnabled: boolean): void {
    if (isEnabled) {
      this.searchForm.get('userType')?.enable();
      this.searchForm.get('userSearch')?.enable();
    } else {
      this.searchForm.get('userType')?.disable();
      this.searchForm.get('userSearch')?.disable();
    }
  }
  onRolesChange(event: any): void {
    // Update the selected roles using the reusable function
    this.updateSelectedRoles(event.target.value, event.target.checked);
  }
  updateSelectedRoles(value: number, isChecked: boolean): void {
    if (isChecked) {
      // Add the role if it is not already in the list
      if (!this.selectedRoles.includes(value)) {
        this.selectedRoles.push(value);
      }
    } else {
      // Remove the role if it exists in the list
      const index = this.selectedRoles.indexOf(value);
      if (index > -1) {
        this.selectedRoles.splice(index, 1);
      }
    }    
  }
  isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined || value === 'null' || value === 'undefined' || value === '';
  }
  getUserDetails() {
    this.clearErrorMsg();
    if (this.searchForm.invalid) {
      this.errorMessage = 'User Search is required.';
      return;
    }
    this.addUserForm.reset(); // Reset the addUserForm    
    this.userExist = false; // Reset user existence state
    let userSearch = this.searchForm.value.userSearch.trim().toLowerCase();
    var record = this.userMaster.filter(user => user.Email.toLowerCase().trim() == userSearch
      || (this.isNullOrUndefined(user.CAI) ? "" : (user.CAI).toLowerCase().trim()) == userSearch
      || (this.isNullOrUndefined(user.LogonId) ? "" : (user.LogonId).toLowerCase().trim()) == userSearch);
    
    if (record.length > 0) {
      //this.displayErrorMsg = true; MANAS_TBD
      this.errorMessage = (record[0].Is_Partner == this.isPartner) ? 'User already exist' : "Please provide proper user details";
    }
    else {
      this.userService.GetUserDetails(userSearch).subscribe((response: any) => {
          
        if (response[0] != null) {
          const email = response[0]['Mail'].trim().toLowerCase();
          const isChevronEmail = (/^[a-zA-Z0-9._%+-]+@chevron\.com$/).test(email);
          var record = this.userMaster.filter(s => s.Email.toLowerCase().trim() == response[0]['Mail'].toLowerCase().trim());
          if (record.length > 0) {
            this.displayErrorMsg = true;
            this.errorMessage = 'User already exist';
          }
          else {
            if ((!this.isPartner && !isChevronEmail)) {
              this.displayErrorMsg = true;
              this.errorMessage = 'Please provide proper user details';
            }
            else if ((this.isPartner && isChevronEmail)) {
              this.displayErrorMsg = true;
              this.errorMessage = 'Please provide proper user details';
            }
            else if ((this.isPartner && response[0]['externalUserState'].trim().toLowerCase().indexOf('accepted') == -1)) {
              //alert(response[0]['externalUserState']);
              this.displayErrorMsg = true;
              this.errorMessage = 'User has not accepted the Guest User Account Invitation.';
            }
            else {
              this.newUser.User_Name = response[0]['givenName'] + ", " + response[0]['surname'];
              this.newUser.Email = response[0]['Mail'];
              this.newUser.JobTitle = response[0]['jobTitle'];
              this.newUser.CTN = (response[0]['businessPhones'] != null) ? response[0]['businessPhones'][0] : "";
              this.newUser.CAI = response[1]['extension_39c7d3e68666465dab296ee0fc538118_extensionAttribute11'];
              this.newUser.LogonId = response[1]['extension_39c7d3e68666465dab296ee0fc538118_sAMAccountName'];
              this.newUser.Is_Partner = this.isPartner //Boolean(JSON.parse(this.IsPartner));
              this.newUser.Company = this.selectedCompany;
              this.newUser.Block = this.selectedBlock;
              this.mapApplicationRolesToCheckboxOptions();
              if (this.newUser.Is_Partner) {
                this.bindCompanyAndBlock();                
              }              
              this.addUserForm.patchValue({
                userName: this.newUser.User_Name,
                email: this.newUser.Email,
                cai: this.newUser.CAI,
                jobTitle: this.newUser.JobTitle,
                ctn: this.newUser.CTN
              });
              this.userExist = true; // Make the form readonly      
              this.buttonLabel = 'Reset';
            }
          }
        }
        else {
          this.displayErrorMsg = true;
          this.errorMessage = 'User not found. Please provide proper user details.';
        }
      });
    }
  }
  createNewUser() {
    this.displayErrorMsg = false;
    this.clearErrorMsg();
    this.newUser = this.getNewUserFormData();    
    if (this.newUser.ApplicationRoles.length == 0) {
      this.displayErrorMsg = true;
      this.errorMessage = 'Please Select Application Role';
    }
    else {
      
      this.adminService.addUser(this.newUser).subscribe((response: any) => {
        if(response.result)
        {
          this.messageService.success("User added successfully!", {nzDuration: Constants.SHOW_MESSAGE_DURATION});
          this.router.navigate(['/admin/user_details']);
        }
        else{
          this.messageService.error("User already exist");
        }
      });
    }
  }
  getNewUserFormData(): RegisteredUserModel {
    const newUserModel: RegisteredUserModel = new RegisteredUserModel();
    newUserModel.Is_Partner = this.isPartner; // Set Is_Partner based on the selected user type
    newUserModel.LogonId = this.addUserForm.get('')?.value; // Set LogonId from the form
    newUserModel.User_Name = this.addUserForm.get('userName')?.value;
    newUserModel.Email = this.addUserForm.get('email')?.value;
    newUserModel.CAI = this.addUserForm.get('cai')?.value;
    newUserModel.JobTitle = this.addUserForm.get('jobTitle')?.value;
    newUserModel.CTN = this.addUserForm.get('ctn')?.value;
    newUserModel.Company.Company_Code = this.addUserForm.get('company')?.value;
    newUserModel.Block.Block_Code = this.addUserForm.get('block')?.value;
    newUserModel.Created_By = this.currentUser.User_Code??0;
    newUserModel.ApplicationRoles = this.selectedRoles.map(role => {
      return role as ApplicationRole; // Convert selected roles to ApplicationRole array
    });   
    return newUserModel;
  }
  bindCompanyAndBlock() {
    this.adminService.GetAllCompanyAndBlock().subscribe((response: any) => {
      this.companyMaster = response.output.Company.filter((comp: CompanyModel) => comp.Active) as CompanyModel[];;
      this.blockMaster = response.output.Block as BlockModel[];;

    });
  }
  patchUserDetails(user: RegisteredUserModel) {
    this.addUserForm.patchValue({
      userName: user.User_Name,
      email: user.Email,
      cai: user.CAI,
      jobTitle: user.JobTitle,
      ctn: user.CTN
    });

  }
  resetToDefault() {
    this.clearErrorMsg();
    this.newUser = new RegisteredUserModel();
    //this.newUser.Company.Company_Code = 0;
    //this.newUser.Block.Block_Code = 0;
    this.selectedCompany = new CompanyModel();
    this.selectedBlock = new BlockModel();
    this.selectedCompany.Company_Code = this.selectedBlock.Block_Code = 0;
  }
  clearErrorMsg() {
    this.displayErrorMsg = false;
    this.errorMessage = "";
  }

}
